import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const hubSpot = defineConnector({
  identifier: "hubSpot",
  name: "HubSpot",
  tagLine: "CRM and marketing platform",
  keywords: "crm sales marketing service hub deals contacts companies inbound",
  logo,
  protocol: "http",
  tags: ["productivity", "communication"],
  defaultUrlPattern: () => "https://api\\.hubapi\\.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Get a private app access token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your [HubSpot private apps settings](https://app.hubspot.com/private-apps/) and create a new private app with the scopes you need.",
        },
      ],
    },
    {
      title: "Copy and paste the access token into the field below",
      items: [
        {
          kind: "input",
          label: "HubSpot access token",
          placeholder: "pat-...",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.hubapi.com/crm/v3/objects/contacts?limit=1",
  },
});
